import usePenetrationReportV2Store from '../../stores/penetrationReportV2Store';
import { BreakdownDimension, BreakdownDimensionType, BreakdownRow } from '../../services/penetrationReportV2/types';
import { breakdownDimensionLabel } from '../../services/penetrationReportV2/penetrationReportV2Service';

const TABS: BreakdownDimensionType[] = Object.values(BreakdownDimension);

interface BreakdownTableProps {
  rows: BreakdownRow[];
  comparisonEnabled: boolean;
}

function BreakdownTable({ rows, comparisonEnabled }: BreakdownTableProps) {
  const breakdownTab = usePenetrationReportV2Store((s) => s.breakdownTab);
  const setBreakdownTab = usePenetrationReportV2Store((s) => s.setBreakdownTab);

  return (
    <section className="pr2-card pr2-breakdown">
      <div className="pr2-heading pr2-breakdown-head">
        <div>
          <h2>Where the market gap is</h2>
          <p>Current penetration compared with prior period</p>
        </div>
        <div className="pr2-tabs">
          {TABS.map((tab) => (
            <button
              type="button"
              key={tab}
              className={tab === breakdownTab ? 'active' : ''}
              onClick={() => setBreakdownTab(tab)}
            >
              By {breakdownDimensionLabel(tab)}
            </button>
          ))}
        </div>
      </div>

      <div className={`pr2-table-head ${comparisonEnabled ? '' : 'no-compare'}`}>
        <span>{breakdownDimensionLabel(breakdownTab)}</span>
        <span>Current</span>
        {comparisonEnabled && <span>Prior</span>}
        {comparisonEnabled && <span>Change</span>}
      </div>

      <div>
        {rows.length === 0 ? (
          <div className="pr2-row-empty">No data for this selection</div>
        ) : rows.map((row) => (
          <div className={`pr2-row ${comparisonEnabled ? '' : 'no-compare'}`} key={row.key}>
            <div className="pr2-entity">
              <strong>{row.label}</strong>
              <small>{row.acquiredCount.toLocaleString()} / {row.targetCount.toLocaleString()} acquired</small>
            </div>
            <div className="pr2-barcell">
              <span className="pr2-bar"><i style={{ width: `${Math.min(100, row.currentPct)}%` }} /></span>
              <b>{row.currentPct.toFixed(1)}%</b>
            </div>
            {comparisonEnabled && <span className="pr2-prior">{row.priorPct.toFixed(1)}%</span>}
            {comparisonEnabled && (
              <strong className="pr2-delta">{row.deltaPct >= 0 ? '+' : ''}{row.deltaPct.toFixed(1)} pp</strong>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}

export default BreakdownTable;
